<div class="spreading-template-table-view-wrapper" appRowLinkHover>
  <table class="spreading-template-table" *ngIf="state && state.columns && state.columns.length > 0">
    <thead>
      <tr class="static-header-row statement-date-row">
        <th rowspan="4" class="label-column thead-label-group-cell">
          <div class="thead-label-group">
            <div class="thead-label-line thead-label-line--primary">
                {{ templateName }}
                <button class="btn btn-link change-template-link-button" *ngIf="changeTemplateActionIsVisible"
                   (click)="emitChangeTemplateClick()" title="Change Template Selection">
                    <span><i class="fas fa-arrow-right-arrow-left edit-template-selection-icon"></i>Change</span>
                </button>
                </div>
            <div class="thead-label-line thead-label-line--secondary">Reporting</div>
            <div class="thead-label-line thead-label-line--secondary">Scenario</div>
            <div class="thead-label-line thead-label-line--secondary thead-label-line--preparation">
              <span>Preparation</span>
              <button
                type="button"
                class="btn btn-link expand-all-btn"
                (click)="toggleExpandAll()"
              >
                  @if(allRowsExpanded) {
                      <span><i class="fa expand-all-icon fa-down-left-and-up-right-to-center"></i>Collapse All</span>
                  } @else {
                      <span><i class="fa expand-all-icon fa-up-right-and-down-left-from-center"></i>Expand All</span>
                  }
                  
              </button>
            </div>
          </div>
        </th>
        <td *ngFor="let pcol of state.previousPeriodColumns" class="data-column data-column--previous">
          <span class="previous-period-indicator"
                title="This data is from a previously completed spread and cannot be edited here.">
            <i class="fa fa-clock-rotate-left"></i>
          </span>
          <i *ngIf="hasPreviousColumnComment(pcol)"
             class="fas fa-comment fa-flip-horizontal header-comment"
             title="This period has a comment on it."></i>
          <i *ngIf="hasPreviousColumnComment(pcol)"
             class="fas fa-ellipsis-vertical previous-period-comment-menu"
             (click)="emitPreviousPeriodColumnViewComment($event, pcol)"
             title="More actions"></i>
          {{ pcol.statementDate || 'Date Missing' }}
        </td>
        <td *ngFor="let column of state.columns; let colIdx = index"
            class="data-column">
          <span *ngIf="previousOnlyCellCountForColumn(colIdx) as prevOnlyCount"
                class="prev-only-badge-wrap"
                (click)="$event.stopPropagation()">
            <span class="prev-only-count-badge">{{ prevOnlyCount }}</span>
            <span class="missing-data-flyout">
              <span class="missing-data-flyout__label">{{ prevOnlyCount }} items with missing data</span>
              <button type="button" class="btn missing-data-flyout__view"
                      (click)="revealPreviousOnlyCells(colIdx, $event)">View →</button>
            </span>
          </span>
          {{ column.statementDate || 'Date Missing' }}
        </td>
      </tr>
      <tr class="static-header-row reporting-row">
        <td *ngFor="let pcol of state.previousPeriodColumns" class="data-column data-column--previous">{{ reportingIntervalDisplay(pcol.reportingInterval) }}</td>
        <td *ngFor="let column of state.columns" class="data-column">{{ reportingIntervalDisplay(column.reportingInterval) }}</td>
      </tr>
      <tr class="static-header-row scenario-row">
        <td *ngFor="let pcol of state.previousPeriodColumns" class="data-column data-column--previous">{{ scenarioDisplay(pcol.scenario) }}</td>
        <td *ngFor="let column of state.columns" class="data-column">{{ scenarioDisplay(column.scenario) }}</td>
      </tr>
      <tr class="static-header-row preparation-row">
        <td *ngFor="let pcol of state.previousPeriodColumns" class="data-column data-column--previous">{{ preparationTypeDisplay(pcol.preparationType) }}</td>
        <td *ngFor="let column of state.columns" class="data-column">{{ preparationTypeDisplay(column.preparationType) }}</td>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of state.rows">
        <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: row, parentIndentation: 0, columns: state.columns, isExpandedChild: false, component: this }"></ng-container>
      </ng-container>
    </tbody>
  </table>
  <div *ngIf="!state || !state.columns || state.columns.length === 0" class="no-data-message">
    <p>No template data available</p>
  </div>
  <app-add-categorization-modal
    *ngIf="showAddCategorizationModal && modalRow"
    [state]="state"
    [row]="modalRow"
    [viewInNativeLanguage]="viewInNativeLanguage"
    [buttonElement]="modalButtonElement"
    [initialView]="modalInitialView"
    (stateChanged)="onModalStateChanged($event)"
    (manualSourceRowInserted)="onManualSourceRowInserted($event)"
    (offsetAdjustmentInserted)="onOffsetAdjustmentInserted($event)"
    (closeModal)="onModalClose($event)"
  ></app-add-categorization-modal>
  <app-recategorize-modal
    *ngIf="showRecategorizeModal && recategorizeRow"
    [state]="state"
    [row]="recategorizeRow"
    [viewInNativeLanguage]="viewInNativeLanguage"
    [buttonElement]="recategorizeButtonElement"
    (stateChanged)="onRecategorizeStateChanged($event)"
    (closeModal)="onRecategorizeModalClose()"
  ></app-recategorize-modal>
</div>

<ng-template
  #templatePaneSourceStatementCell
  let-row="row"
  let-colIdx="colIdx"
  let-component="component"
>
  <app-statement-table-cell
    class="grid-nav-cell"
    tabindex="0"
    [cellForSourceComments]="row.cells[colIdx]"
    [value]="row.cells[colIdx].roundedRawText"
    [confidence]="row.cells[colIdx].confidence"
    (rerenderEvent)="component.onStatementCellRerender()"
    (cellValueChanged)="component.emitCellValueChanged($event, row, colIdx)"
    (enteredEditMode)="component.emitCellEditStart(row, colIdx)"
    [isEditing]="row.cellEditingIndex === colIdx && component.cellEditFocusPane === 'template'"
    [isEditingDisabled]="component.isCellEditingDisabledForSourceRow(row)"
    [isSelected]="row.cellSelectedIndex === colIdx"
    [isNumeric]="component.cellValueIsNumeric(row.cells[colIdx])"
    [textFormat]="row.textFormat"
    (cellSelected)="component.emitCellSelect(row, colIdx)"
    (click)="component.emitCellSelect(row, colIdx)"
    (focus)="component.emitCellSelect(row, colIdx)"
    (blur)="component.onCellBlur($event)"
    (rightClickedOnCell)="component.emitCellContextMenu($event, row, row.cells[colIdx], colIdx)"
    (valueBeforeEditsMade)="component.emitCellValueBeforeEdit($event)"
    (keydown)="component.onTemplateCellKeydown(row, colIdx, $event)"
  ></app-statement-table-cell>
</ng-template>

<ng-template #sourceRowInteractiveLabel let-row="row" let-component="component" let-validation="validation">
  <div
    class="line-item template-source-line-item"
    [class.template-source-line-item--validation]="validation"
    [class.grid-nav-cell]="!component.isSourceLabelEditDisabled(row)"
    [attr.tabindex]="component.isSourceLabelEditDisabled(row) ? null : 0"
    [class.percent-padding]="row.itemClass === 'AdjustedStandardItem' || row.itemClass === 'NonAdjustableStandardItem'"
    [class.editing]="component.isEditingSourceRowLabel(row)"
    [ngClass]="{
      'calculated': row.calculated,
      'suggested': row.suggestedChange
    }"
    [title]="component.labelDisplayValue(row)"
    (click)="component.onSourceLineItemLabelClick(row)"
    (focus)="component.onSourceLineItemLabelClick(row)"
    (blur)="component.onCellBlur($event)"
    (keydown)="component.onSourceLabelKeydown(row, $event)"
  >
    <app-double-click-to-edit
      [value]="component.labelDisplayValue(row)"
      (changed)="component.emitSourceLabelChanged($event, row)"
      (enteredEditMode)="component.emitSourceLabelEditStart(row)"
      [editing]="component.isEditingSourceRowLabel(row)"
      [invertValue]="row.invertValue"
      [isEditingDisabled]="component.isSourceLabelEditDisabled(row)"
      [footnotePresent]="!!row?.footnotes?.length"
      [isUserAddedRow]="row?.isUserAddedRow"
      [isOffsetLinkRow]="component.isDerivedOffsetRow(row)"
      [offsetLinkTooltip]="component.offsetLinkTooltip(row)"
      [placeholder]="row?.isUserAddedRow ? component.MANUAL_ITEM_LABEL_PLACEHOLDER : ''"
    ></app-double-click-to-edit>
  </div>
  <span *ngIf="validation" class="label-text--validation-suffix">v</span>
  <i *ngIf="row.itemClass !== 'supplementalItem'"
     class="fas fa-ellipsis-vertical label-source-menu-icon"
     (click)="component.emitSourceRowLabelContextMenu($event, row)"
     title="More actions"></i>
</ng-template>

<ng-template #rowTemplate let-row let-parentIndentation="parentIndentation" let-columns="columns" let-isExpandedChild="isExpandedChild" let-component="component">
  <tr
    [attr.data-row-key]="row.uuid"
    [ngClass]="{
      'header-row': row.header,
      'expanded-child-row': isExpandedChild,
      'spread-row--validation-offby': row.validationRow && component.rowHasValidationOffBy(row)
    }"
  >
    <td
      class="label-column"
      [appFsMask]="isExpandedChild && component.isTemplateLinkedSourceRow(row)"
      [class.translated-label-cell]="
        !component.viewInNativeLanguage && component.rowHasTranslation(row)
      "
      [class.label-cell-selected]="row.labelSelected || component.recategorizeRow === row || (component.modalRow === row && !row.rollupName)"
    >
      <div class="label-content">
        <div class="label-left-content">
          <div [className]="'indent indent-' + (isExpandedChild ? parentIndentation + 1 : (row.indentation !== undefined ? row.indentation : parentIndentation))"></div>
          <i *ngIf="!row.header && !row.calculated && (!isExpandedChild || component.hasExpandableChildren(row))"
             class="fas expand-collapse-icon"
             [class.grid-nav-cell]="component.hasExpandableChildren(row)"
             [attr.tabindex]="component.hasExpandableChildren(row) ? 0 : null"
             [ngClass]="{
               'fa-chevron-right': !component.isRowExpanded(row),
               'fa-chevron-down': component.isRowExpanded(row),
               'disabled': !component.hasExpandableChildren(row)
             }"
             (click)="component.hasExpandableChildren(row) && component.toggleRowExpansion(row, $event)"
             (keydown)="component.onChevronKeydown(row, $event)"
             title="{{ component.hasExpandableChildren(row) ? (component.isRowExpanded(row) ? 'Collapse' : 'Expand') : 'No children to expand' }}"></i>
          <ng-container *ngIf="component.isTemplateLinkedSourceRow(row); else tplReadonlyLabel">
            <ng-container *ngTemplateOutlet="sourceRowInteractiveLabel; context: { row: row, component: component }"></ng-container>
          </ng-container>
          <ng-template #tplReadonlyLabel>
            <ng-container *ngIf="{ text: component.templateTreeReadonlyLabel(row) } as roLabel">
              <span
                class="label-text"
                [class.label-text--calculated]="!!row.calculated"
                [title]="roLabel.text"
              >{{ roLabel.text }}</span>
            </ng-container>
          </ng-template>
          <span *ngIf="component.hasExpandableChildren(row) && !row.calculated" class="children-count-badge">{{ component.expandableChildrenCount(row) }}</span>
        </div>
        <div class="label-right-content">
            <ng-container *ngIf="isExpandedChild">
                <i *ngIf="row?.isPreviousOnlyRow; else nonPreviousOnlyChildIcon"
                   class="fas fa-lock label-lock-icon label-icon"
                   title="This item cannot be deleted as it's from a previous spread. Document items in the current spread can still be categorized to this template item."></i>
                <ng-template #nonPreviousOnlyChildIcon>
                  <i *ngIf="row?.itemClass==='supplementalItem'; else removeCategorizationButton"
                     class="fas fa-lock label-lock-icon label-icon"
                     title="This categorization is locked and cannot be changed"></i>
                  <ng-template #removeCategorizationButton>
                      <i class="fas fa-arrows-left-right recategorize-categorization-icon label-icon grid-nav-cell"
                         tabindex="0"
                         (click)="component.openRecategorizeModal(row, $event)"
                         (keydown)="component.onRecategorizeKeydown(row, $event)"
                         title="Recategorize Item"></i>
                      <i class="fas fa-times remove-categorization-icon label-icon grid-nav-cell"
                         tabindex="0"
                         (click)="component.removeCategorization(row, $event)"
                         (keydown)="component.onRemoveCategorizationKeydown(row, $event)"
                         title="Remove Categorization"></i>
                  </ng-template>
                </ng-template>
            </ng-container>
          <i
            *ngIf="!isExpandedChild && !row.rollupName && !row.header"
            class="fas fa-plus add-categorization-icon label-icon grid-nav-cell"
            tabindex="0"
            (click)="component.addCategorization(row, $event)"
            (keydown)="component.onAddControlKeydown(row, $event)"
            title="Add Categorization"
          ></i>
        </div>
      </div>
    </td>
    <td
      *ngFor="let pcol of component.state.previousPeriodColumns; let pIdx = index"
      class="data-column data-column--previous"
    >
      <ng-container *ngIf="!row.header">
        <ng-container *ngTemplateOutlet="prevPeriodCell; context: { row: row, pIdx: pIdx, requireLineItem: true, component: component }"></ng-container>
      </ng-container>
    </td>
    <td
      *ngFor="let column of columns; let colIdx = index"
      class="data-column"
      [class.no-padding]="component.isTemplateLinkedSourceRow(row)"
      [class.hard-stop-warning]="!row.rollupName && row.cells[colIdx]?.submissionRuleResultsStatus == SubmissionRuleActions.HARD_STOP"
      [class.soft-stop-warning]="!row.rollupName && row.cells[colIdx]?.submissionRuleResultsStatus == SubmissionRuleActions.SOFT_STOP"
      [class.cell--prev-only]="component.isPreviousOnlyMissingCell(row, colIdx)"
      [attr.data-prev-only-col]="component.isPreviousOnlyMissingCell(row, colIdx) ? colIdx : null"
      [ngClass]="{
        'selected-celll':
          component.isTemplateLinkedSourceRow(row) &&
          row.cellSelectedIndex === colIdx
      }"
    >
      <ng-container *ngIf="!row.rollupName">
        <ng-container *ngTemplateOutlet="submissionRuleWarningIcon; context: { row: row, colIdx: colIdx }"></ng-container>
      </ng-container>
      <span *ngIf="component.isPreviousOnlyMissingCell(row, colIdx)" class="prev-only-missing-value">-</span>
      <ng-container *ngIf="!row.header && row.cells && row.cells[colIdx]">
        <ng-container *ngIf="component.isTemplateLinkedSourceRow(row)">
          <ng-container *ngIf="row.validationRow">
            <div class="template-data-cell-stack">
              <div
                class="template-data-cell-value"
                [class.template-data-cell-value--ok]="row.cells[colIdx].flag === false"
                [class.template-data-cell-value--flagged]="row.cells[colIdx].flag === true"
              >
                <div
                  class="outer-height"
                  [class.percent-padding]="
                    row.itemClass === 'AdjustedStandardItem' ||
                    row.itemClass === 'NonAdjustableStandardItem'
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="
                      templatePaneSourceStatementCell;
                      context: { row: row, colIdx: colIdx, component: component }
                    "
                  ></ng-container>
                </div>
              </div>
              <div
                *ngIf="
                  row.cells[colIdx].flag === true &&
                  row.cells[colIdx].offBy != null &&
                  row.cells[colIdx].offBy !== 0
                "
                class="template-data-cell-offby"
              >
                <span *ngIf="row.cells[colIdx].offBy > 0">+</span>
                <ng-container *ngIf="component.templateOffByDisplay(row, colIdx) as ob">
                  {{ ob.rounded | number: '1.2-2' }}
                </ng-container>
              </div>
            </div>
          </ng-container>
          <div
            *ngIf="!row.validationRow"
            class="outer-height"
            [class.percent-padding]="
              row.itemClass === 'AdjustedStandardItem' ||
              row.itemClass === 'NonAdjustableStandardItem'
            "
          >
            <ng-container
              *ngTemplateOutlet="
                templatePaneSourceStatementCell;
                context: { row: row, colIdx: colIdx, component: component }
              "
            ></ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="!component.isTemplateLinkedSourceRow(row)">
          <ng-container *ngIf="row.validationRow">
            <div class="template-data-cell-stack">
              <div
                class="template-data-cell-value"
                [class.template-data-cell-value--ok]="row.cells[colIdx].flag === false"
                [class.template-data-cell-value--flagged]="row.cells[colIdx].flag === true"
              >
                <ng-container *ngIf="component.templateCellDisplay(row, colIdx) as d">
                  <span
                    class="data-cell-text"
                    [appBsTooltip]="d.rounded | number: '1.2-2'"
                    [onlyWhenTruncated]="true"
                  >{{ d.rounded | number: '1.2-2' }}</span>
                </ng-container>
              </div>
              <div
                *ngIf="
                  row.cells[colIdx].flag === true &&
                  row.cells[colIdx].offBy != null &&
                  row.cells[colIdx].offBy !== 0
                "
                class="template-data-cell-offby"
              >
                <span *ngIf="row.cells[colIdx].offBy > 0">+</span>
                <ng-container *ngIf="component.templateOffByDisplay(row, colIdx) as ob">
                  {{ ob.rounded | number: '1.2-2' }}
                </ng-container>
              </div>
              <ng-container *ngTemplateOutlet="goalSeekCellButton; context: { row: row, colIdx: colIdx, component: component }"></ng-container>
            </div>
          </ng-container>
          <ng-container
            *ngIf="!row.validationRow && component.templateCellDisplay(row, colIdx) as d"
          >
            <span
              class="data-cell-text"
              [appBsTooltip]="d.rounded | number: '1.2-2'"
              [onlyWhenTruncated]="true"
            >{{ d.rounded | number: '1.2-2' }}</span>
          </ng-container>
        </ng-container>
      </ng-container>
    </td>
  </tr>
  <!-- Header row children (always shown) -->
  <ng-container *ngIf="row.header && row.children && row.children.length > 0">
    <ng-container *ngFor="let childRow of row.children">
      <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: childRow, parentIndentation: (row.indentation !== undefined ? row.indentation : parentIndentation) + 1, columns: columns, isExpandedChild: false, component: component }"></ng-container>
    </ng-container>
  </ng-container>
  <!-- Non-header row children (shown when expanded) -->
  <ng-container *ngIf="!row.header && component.isRowExpanded(row) && row.children && row.children.length > 0">
    <ng-container *ngFor="let childRow of row.children">
      <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: childRow, parentIndentation: (row.indentation !== undefined ? row.indentation : parentIndentation) + 1, columns: columns, isExpandedChild: true, component: component }"></ng-container>
    </ng-container>
  </ng-container>
  <!-- Prior-only synthetic children (rendered after current children, same visibility rules) -->
  <ng-container *ngIf="row.header && row.previousOnlyChildren && row.previousOnlyChildren.length > 0">
    <ng-container *ngFor="let childRow of row.previousOnlyChildren">
      <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: childRow, parentIndentation: (row.indentation !== undefined ? row.indentation : parentIndentation) + 1, columns: columns, isExpandedChild: false, component: component }"></ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!row.header && component.isRowExpanded(row) && row.previousOnlyChildren && row.previousOnlyChildren.length > 0">
    <ng-container *ngFor="let childRow of row.previousOnlyChildren">
      <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: childRow, parentIndentation: (row.indentation !== undefined ? row.indentation : parentIndentation) + 1, columns: columns, isExpandedChild: true, component: component }"></ng-container>
    </ng-container>
  </ng-container>
  <!-- Rollup total line (legacy template-row calculation li; uses cell.value only) -->
  <tr
    *ngIf="row.rollupName"
    class="expanded-child-row template-rollup-total-row"
    [class.spread-row--validation-offby]="row.validationRow && component.rowHasValidationOffBy(row)"
  >
    <td
      class="label-column"
      [class.label-cell-selected]="component.modalRow === row"
    >
      <div class="label-content">
        <div class="label-left-content">
          <div
            [className]="
              'indent indent-' +
              component.rollupLabelIndentLevel(row, parentIndentation, isExpandedChild)
            "
          ></div>
          <span class="label-text label-text--rollup">{{ row.rollupName }}</span>
        </div>
        <div class="label-right-content">
          <i
            class="fas fa-plus add-categorization-icon label-icon grid-nav-cell"
            tabindex="0"
            (click)="component.addCategorization(row, $event)"
            (keydown)="component.onAddControlKeydown(row, $event)"
            title="Add Categorization"
          ></i>
        </div>
      </div>
    </td>
    <td
      *ngFor="let pcol of component.state.previousPeriodColumns; let pIdx = index"
      class="data-column data-column--previous"
    >
      <ng-container *ngTemplateOutlet="prevPeriodCell; context: { row: row, pIdx: pIdx, requireLineItem: false, component: component }"></ng-container>
    </td>
    <td
      *ngFor="let column of columns; let colIdx = index"
      class="data-column"
      [class.hard-stop-warning]="row.cells?.[colIdx]?.submissionRuleResultsStatus == SubmissionRuleActions.HARD_STOP"
      [class.soft-stop-warning]="row.cells?.[colIdx]?.submissionRuleResultsStatus == SubmissionRuleActions.SOFT_STOP"
    >
      <ng-container *ngTemplateOutlet="submissionRuleWarningIcon; context: { row: row, colIdx: colIdx }"></ng-container>
      <ng-container *ngIf="row.cells && row.cells[colIdx]">
        <ng-container *ngIf="row.validationRow">
          <div class="template-data-cell-stack">
            <div
              class="template-data-cell-value"
              [class.template-data-cell-value--ok]="row.cells[colIdx].flag === false"
              [class.template-data-cell-value--flagged]="row.cells[colIdx].flag === true"
            >
              <ng-container *ngIf="component.templateRollupValueDisplay(row, colIdx) as rv">
                <span
                  class="data-cell-text"
                  [appBsTooltip]="rv.rounded | number: '1.2-2'"
                  [onlyWhenTruncated]="true"
                >{{ rv.rounded | number: '1.2-2' }}</span>
              </ng-container>
            </div>
            <div
              *ngIf="
                row.cells[colIdx].flag === true &&
                row.cells[colIdx].offBy != null &&
                row.cells[colIdx].offBy !== 0
              "
              class="template-data-cell-offby"
            >
              <span *ngIf="row.cells[colIdx].offBy > 0">+</span>
              <ng-container *ngIf="component.templateOffByDisplay(row, colIdx) as ob">
                {{ ob.rounded | number: '1.2-2' }}
              </ng-container>
            </div>
            <ng-container *ngTemplateOutlet="goalSeekCellButton; context: { row: row, colIdx: colIdx, component: component }"></ng-container>
          </div>
        </ng-container>
        <ng-container
          *ngIf="!row.validationRow && component.templateRollupValueDisplay(row, colIdx) as rv"
        >
          <span
            class="data-cell-text"
            [appBsTooltip]="rv.rounded | number: '1.2-2'"
            [onlyWhenTruncated]="true"
          >{{ rv.rounded | number: '1.2-2' }}</span>
        </ng-container>
      </ng-container>
    </td>
  </tr>
  <tr
    *ngIf="row.validationRow"
    class="expanded-child-row template-validation-row"
    [attr.data-row-key]="row.validationRow.uuid"
  >
    <td
      class="label-column"
      [appFsMask]="true"
      [class.translated-label-cell]="
        !component.viewInNativeLanguage &&
        row.validationRow &&
        component.rowHasTranslation(row.validationRow)
      "
      [class.label-cell-selected]="row.validationRow.labelSelected || component.recategorizeRow === row.validationRow"
    >
      <div class="label-content">
        <div class="label-left-content">
          <div
            [className]="
              'indent indent-' +
              component.validationRowLabelIndentLevel(row, parentIndentation, isExpandedChild)
            "
          ></div>
          <ng-container *ngTemplateOutlet="sourceRowInteractiveLabel; context: { row: row.validationRow, component: component, validation: true }"></ng-container>
        </div>
          <div class="label-right-content">
              <i *ngIf="row.validationRow?.isPreviousOnlyRow; else removeValidationCategorizationButton"
                 class="fas fa-lock label-lock-icon remove-categorization-icon label-icon"
                 title="This item cannot be deleted as it's from a previous spread. Document items in the current spread can still be categorized to this template item."></i>
              <ng-template #removeValidationCategorizationButton>
                <i class="fas fa-arrows-left-right recategorize-categorization-icon label-icon grid-nav-cell"
                   tabindex="0"
                   (click)="component.openRecategorizeModal(row.validationRow, $event)"
                   (keydown)="component.onRecategorizeKeydown(row.validationRow, $event)"
                   title="Recategorize Item"></i>
                <i class="fas fa-times remove-categorization-icon label-icon grid-nav-cell"
                   tabindex="0"
                   (click)="component.removeCategorization(row.validationRow, $event)"
                   (keydown)="component.onRemoveCategorizationKeydown(row.validationRow, $event)"
                   title="Remove Categorization"></i>
              </ng-template>
          </div>
      </div>
    </td>
    <td *ngFor="let pcol of component.state.previousPeriodColumns; let pIdx = index" class="data-column data-column--previous">
      <ng-container *ngTemplateOutlet="prevPeriodCell; context: { row: row.validationRow, pIdx: pIdx, requireLineItem: false, component: component }"></ng-container>
    </td>
    <td
      *ngFor="let column of columns; let colIdx = index"
      class="data-column no-padding"
      [ngClass]="{ 'selected-celll': row.validationRow.cellSelectedIndex === colIdx }"
    >
      <ng-container *ngIf="row.validationRow.cells && row.validationRow.cells[colIdx]">
        <div
          class="outer-height"
          [class.percent-padding]="
            row.validationRow.itemClass === 'AdjustedStandardItem' ||
            row.validationRow.itemClass === 'NonAdjustableStandardItem'
          "
        >
          <ng-container
            *ngTemplateOutlet="
              templatePaneSourceStatementCell;
              context: { row: row.validationRow, colIdx: colIdx, component: component }
            "
          ></ng-container>
        </div>
      </ng-container>
    </td>
  </tr>
</ng-template>

<!--
  Shared prev-period cell renderer.
  - When `row` has its own `validationRow`, renders the full validation
    stack (value with ok/flagged styling + offBy line). Used by main and
    rollup rows that are themselves validated.
  - Otherwise renders a plain rounded value with a "—" placeholder when
    the prior value is missing. Used by validation-row prev cells (we
    pass `row.validationRow` in) and by uncategorized template rows.
  - `requireLineItem`: when true, the "—" placeholder is suppressed
    unless `row.lineItemId != null` (matches the main-row site, which
    skips the placeholder for non-line-item rows).
-->
<ng-template
  #prevPeriodCell
  let-row="row"
  let-pIdx="pIdx"
  let-requireLineItem="requireLineItem"
  let-component="component"
>
  <ng-container *ngIf="row.validationRow">
    <div class="template-data-cell-stack">
      <div
        class="template-data-cell-value"
        [class.template-data-cell-value--ok]="row.previousCells && row.previousCells[pIdx] && row.previousCells[pIdx].flag === false"
        [class.template-data-cell-value--flagged]="row.previousCells && row.previousCells[pIdx] && row.previousCells[pIdx].flag === true"
      >
        <div class="previous-period-cell-content">
          <i *ngIf="component.hasPreviousCellComment(row, pIdx)"
             class="fas fa-ellipsis-vertical previous-period-comment-menu"
             (click)="component.emitPreviousPeriodCellViewComment($event, row, pIdx)"
             title="More actions"></i>
          <app-comment-present-indicator
            *ngIf="component.hasPreviousCellComment(row, pIdx)"
            [sourceComments]="row.previousCells[pIdx]?.sourceComments"
          ></app-comment-present-indicator>
          <ng-container *ngIf="component.previousCellDisplay(row, pIdx) as d; else prevPeriodCellMissing">
            <span
              class="data-cell-text"
              [appBsTooltip]="d.rounded | number: '1.2-2'"
              [onlyWhenTruncated]="true"
            >{{ d.rounded | number: '1.2-2' }}</span>
          </ng-container>
          <ng-template #prevPeriodCellMissing>
            <span class="previous-period-missing"
                  title="This item does not exist in the previous spread.">-</span>
          </ng-template>
        </div>
      </div>
      <div
        *ngIf="row.previousCells && row.previousCells[pIdx] && row.previousCells[pIdx].flag === true
               && row.previousCells[pIdx].offBy != null && row.previousCells[pIdx].offBy !== 0"
        class="template-data-cell-offby"
      >
        <span *ngIf="row.previousCells[pIdx].offBy > 0">+</span>
        <ng-container *ngIf="component.previousOffByDisplay(row, pIdx) as ob">
          {{ ob.rounded | number: '1.2-2' }}
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!row.validationRow">
    <div class="previous-period-cell-content">
      <i *ngIf="component.hasPreviousCellComment(row, pIdx)"
         class="fas fa-ellipsis-vertical previous-period-comment-menu"
         (click)="component.emitPreviousPeriodCellViewComment($event, row, pIdx)"
         title="More actions"></i>
      <app-comment-present-indicator
        *ngIf="component.hasPreviousCellComment(row, pIdx)"
        [sourceComments]="row.previousCells[pIdx]?.sourceComments"
      ></app-comment-present-indicator>
      <ng-container *ngIf="component.previousCellDisplay(row, pIdx) as d">
        <span
          class="data-cell-text"
          [appBsTooltip]="d.rounded | number:'1.2-2'"
          [onlyWhenTruncated]="true"
        >{{ d.rounded | number:'1.2-2' }}</span>
      </ng-container>
      <ng-container *ngIf="(!row.previousCells || !row.previousCells[pIdx] || row.previousCells[pIdx].value == null) && (!requireLineItem || row.lineItemId != null)">
        <span class="previous-period-missing"
              title="This item does not exist in the previous spread.">-</span>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #submissionRuleWarningIcon let-row="row" let-colIdx="colIdx">
  <i
    *ngIf="row.cells?.[colIdx]?.submissionRuleResultsStatus == SubmissionRuleActions.HARD_STOP || row.cells?.[colIdx]?.submissionRuleResultsStatus == SubmissionRuleActions.SOFT_STOP"
    class="fas fa-triangle-exclamation submission-rule-warning-icon"
    [appBsTooltip]="submissionRuleTooltip(row, colIdx)"
    [tooltipHtml]="true"
    tooltipClass="submission-rule-tooltip"
  ></i>
</ng-template>

<ng-template #goalSeekCellButton let-row="row" let-colIdx="colIdx" let-component="component">
  <button
    *ngIf="component.enableGoalSeek && row.cells[colIdx]?.flag"
    type="button"
    class="btn btn-light-primary goal-seek-cell-button"
    [class.goal-seek-cell-button--active]="component.isActiveGoalSeekCell(row, colIdx)"
    [appBsTooltip]="component.isActiveGoalSeekCell(row, colIdx) ? 'Hide Spread Assist' : 'Spread Assist'"
    (click)="component.onGoalSeekCellClick(row, colIdx, $event)"
  >
    <i class="fas fa-wand-magic-sparkles"></i>
    <span
      *ngIf="component.isActiveGoalSeekCell(row, colIdx) && component.state.goalSeekCount > 0"
      class="goal-seek-cell-button__count"
    >{{ component.state.goalSeekCount }}</span>
    <div *ngIf="row.goalSeekInProgress" class="loader button-loader"></div>
  </button>
</ng-template>
